export default __webpack_public_path__ + "static/media/languageselecticon.52f04a22.svg";